import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';
import { format as stringFormat} from 'react-string-format'; 

import { LBL_FEEDBACK,LBL_CLIENT, LBL_EVENT, LBL_TITLE, LBL_REVIEWED_BY, LBL_REVIEWED_BY_CLIENT_ASSOC, LBL_DATE_TO,LBL_RATING, LBL_SHIFT_DATE_FROM, LBL_STAR,LBL_ACTION_TAKEN,LBL_ALL,LBL_YES,LBL_NO,LBL_CREW, LBL_FILTER_CLIENT_FEEDBACK, LBL_FILTER_CHIEF_FEEDBACK, LBL_DEPARTMENTS } from '../../configs/labelConfigs';
import { CREW_MAX_RATING,FEEDBACK_ACTION_DEFAULT,FEEDBACK_ACTION_REQUIRED,FEEDBACK_ACTION_TAKEN } from '../../configs/staticConfigs'; 
import { MSG_FILTER_COMMON_ERROR, MSG_REQUIRED } from '../../configs/msgConfigs'; 

import CustomMultiSelect from '../../components/commons/helpers/customMultiSelect';

import { filterClientsListAction } from '../../actions/eventActions'; 
import { feedbackFilterEventsListAction,feedbackFilterReviewersListAction, feedbackGetChiefReviewersListAction } from '../../actions/filterActions';

import {titleCase} from '../../utils/changeCase';
import { getUserGroupData } from '../../utils/browserStorage';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

import * as types from '../../actions';
import {fromDashboard,serverTimeAction,feedbackTitle} from '../../actions/commonActions';
import { aflt_departmentsListAction } from '../../actions/settings/affiliates/aflt_departmentActions';

let starRatingData = []; // FOT MULTISELECT CONTROL 
CREW_MAX_RATING.forEach(item => {
    starRatingData.push({value:item,label:item+' '+LBL_STAR}); 
});

class FilterFeedback extends Component {
    
    constructor(props){
        super(props)
        this.state = { 
            
            clientListCalled: 0, 

            selectedClientId: this.props.clientId?this.props.clientId:0,   
            selectedClient: this.props.clientId?[{id:this.props.clientId, name:''}] : [],   
            clientsOptions: [],

            selectedEventId: 0, 
            selectedEvent: [], 
            eventsOptions: [], 

            selectedReviewerId: 0, 
            selectedReviewer: [], 
            reviewerOptions: [],

            chief_selectedReviewerId: 0, 
            chief_selectedReviewer: [],
            chief_reviewerOptions: [],

            starRatingIds: [],

            includeDate: true, 
            selectedStartDate: this.props.defaultStartDate?this.props.defaultStartDate:'',
            selectedEndDate: this.props.defaultEndDate?this.props.defaultEndDate:'',
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dateValue:0,
            formErrors_commonErr: '',
            formErrors_selectedToDate:'',
            selActionTaken:FEEDBACK_ACTION_DEFAULT,
            selClientFeedback: 'all',
            selCrewFeedback: 'all',
            departmentsList:[],
            deptMultiSelList:[],
            selectedDepartments:[],
        }
    }

    onFeedbackTypeChange = (e,fdbkType) => {
        let selOption = e.target.value;
        if(fdbkType==="selClientFeedback") {
            this.setState({selClientFeedback:selOption})
        } 
        else if(fdbkType==="selCrewFeedback") {
            this.setState({selCrewFeedback:selOption})
        } 
    }

    onActionTakenDataChange = (e) => {
        let selOption = e.target.value;
        if(selOption==FEEDBACK_ACTION_REQUIRED || selOption==FEEDBACK_ACTION_TAKEN) {
            // SET STAR RATINGS AS 1 AND 2 only 
            let negArray = [1,2]
            starRatingData = [];
            CREW_MAX_RATING.forEach(starRate => {
                if(negArray.includes(starRate)) {
                    starRatingData.push({value:starRate,label:starRate+' '+LBL_STAR,inputVal:1}); 
                }
                else {
                    starRatingData.push({value:starRate,label:starRate+' '+LBL_STAR});
                }
            });
            this.setState({selActionTaken:selOption,starRatingIds:negArray}); 
        }
        else {
            this.setState({selActionTaken:selOption}); 
        }
    }

    handleClientChange = (selectedClient) => {
        let clId = 0; 
        let selClient = []; 
        if(selectedClient.length>0){
            selClient = selectedClient; 
            clId = selectedClient[0].id; 
            let dataObj = {clientsIds:[clId]}; 
            this.props.feedbackFilterEventsListAction(dataObj); 
            this.props.feedbackFilterReviewersListAction(dataObj); 
        } 
        this.setState({selectedClient:selClient, selectedClientId:clId, formErrors_commonErr:''});  
    }
    
    handleRemoveClient = (e) => { 
        if(e==='') {
            this.setState({selectedClient:[], selectedClientId:0, formErrors_commonErr:''}, () => { 
                this.props.feedbackFilterEventsListAction(); 
                this.props.feedbackFilterReviewersListAction(); 
            }); 
        } 
    }

    handleEventChange = (selectedEvent) => {
        let eventId = 0; 
        let selEvent = []; 
        if(selectedEvent.length>0){
            selEvent = selectedEvent; 
            eventId = selectedEvent[0].id; 
            let dataObj = {isEvent:1}; 
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)],eventIds:[eventId]}; 
            }
            else {
                let arrClientIds = []
                if(this.state.selectedClient.length) {
                    this.state.selectedClient.forEach(item => {
                        arrClientIds.push(item.id)
                    }) 
                }

                if(arrClientIds.length) {
                    dataObj = {isEvent:1,clientsIds:arrClientIds,eventIds:[eventId]}; 
                }
                else {
                    dataObj = {isEvent:1,eventIds:[eventId]}; 
                }
            }

        } 
        this.setState({selectedEvent:selEvent, selectedEventId:eventId, formErrors_commonErr:''});  
    }
    
    handleRemoveEvent = (e) => {
        if(e==='') {
            this.setState({selectedEvent:[], selectedEventId:0, formErrors_commonErr:''});  
        } 
    }

    handleReviewedbyChange = (selectedItem) => {
        let reviewerId = 0; 
        let selReviewer = []; 
        if(selectedItem.length>0){
            selReviewer = selectedItem; 
            reviewerId = selectedItem[0].id; 
        } 
        this.setState({selectedReviewer:selReviewer, selectedReviewerId:reviewerId, formErrors_commonErr:''});  
    }

    handleRemoveReviewedby = (e) => {
        if(e==='') {
            this.setState({selectedReviewer:[], selectedReviewerId:0, formErrors_commonErr:''});  
        } 
    }

    handleChiefReviewedbyChange = (selectedItem) => {
        let reviewerId = 0; 
        let selReviewer = []; 
        if(selectedItem.length>0){
            selReviewer = selectedItem; 
            reviewerId = selectedItem[0].id; 
        } 
        this.setState({chief_selectedReviewer:selReviewer, chief_selectedReviewerId:reviewerId, formErrors_commonErr:''});  
    } 

    handleRemoveChiefReviewedby = (e) => {
        if(e==='') {
            this.setState({chief_selectedReviewer:[], chief_selectedReviewerId:0, formErrors_commonErr:''});  
        } 
    }

    onStarRatingDataChange = (selectedStatus) =>{
        let selActionTaken = this.state.selActionTaken;
        if(!selectedStatus.length) selActionTaken = FEEDBACK_ACTION_DEFAULT; 
        let starRatingIds = [];
        selectedStatus.forEach((item) => {
            starRatingIds.push(parseInt(item.value,10));
            // IF STAR RATE > 2 SELECTED, THEN RESET ACTION TAKEN FILTER TO DEFAULT 
            if(parseInt(item.value,10) > 2) selActionTaken = FEEDBACK_ACTION_DEFAULT; 
        });
        this.setState({starRatingIds:starRatingIds, formErrors_commonErr:'', selActionTaken});
    }

    onDateCheck = (e) => {
        this.setState({includeDate:!this.state.includeDate, dateValue:1-this.state.dateValue, formErrors_commonErr:''}) 
    }
    
    onStartDateChange = (date) =>{
        let startDate = new Date(date);
        
        if(this.state.selectedEndDate < startDate) {
            this.setState({selectedStartDate:startDate,selectedEndDate:startDate, formErrors_commonErr:''});    
        }
        else {
            this.setState({selectedStartDate:startDate, formErrors_commonErr:''});    
        }
    }

    onEndDateChange = (date) =>{ 
        let endDate = new Date(date);
        this.setState({selectedEndDate:endDate, formErrors_commonErr:''});  
    }

    resetFilters = () => { 
        starRatingData = []; // TO RESET MULTISEL VALUES

        this.setState({ 
            selectedClientId: 0,   
            selectedClient: [],   

            selectedEventId: 0, 
            selectedEvent: [], 

            selectedReviewerId: 0, 
            selectedReviewer: [], 

            chief_selectedReviewerId: 0, 
            chief_selectedReviewer: [], 

            starRatingIds: [], 

            includeDate: true, 
            selectedStartDate: this.props.defaultStartDate?this.props.defaultStartDate:new Date(),
            selectedEndDate: this.props.defaultEndDate?this.props.defaultEndDate:new Date(),
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dateValue:0,
            formErrors_commonErr: '',
            formErrors_selectedToDate:'',
            selClientFeedback: 'all',
            selCrewFeedback: 'all',
        }); 

        // TO RESET MULTISEL VALUES 
        CREW_MAX_RATING.forEach(item => {
            starRatingData.push({value:item,label:item+' '+LBL_STAR}); 
        });
        
        if(this.props.clientId && this.props.clientId > 0) {
            let storageData = getUserGroupData('client'); 
            let dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
            this.props.feedbackFilterEventsListAction(dataObj); 
            this.props.feedbackFilterReviewersListAction(dataObj);
        }
        else {
            this.props.filterClientsListAction(); 
            let dataObj = {isEvent:1}; 
            this.props.feedbackFilterEventsListAction(dataObj); 
            this.props.feedbackFilterReviewersListAction(dataObj);
        }

        this.loadMultiSelDeptValues(true); 
    }

    sendFilterData = () => {

        if(this.props.dataViewType===this.props.dataViewTypeClient && this.state.selCrewFeedback!=='all') {
            this.setState({selCrewFeedback:'all'});
        }
        else if(this.props.dataViewType===this.props.dataViewTypeChief && this.state.selClientFeedback!=='all') {
            this.setState({selClientFeedback:'all'});
        }

        let foundIssues = 0;

        //CHECK ANY OF THE FILTER ITEM IS SELECTED
        // if(this.state.selectedClient.length===0 && this.state.selectedEvent.length===0 && this.state.selectedReviewer.length===0 && this.state.starRatingIds.length===0 && !this.state.includeDate) {
        //     foundIssues = 1;
        //     this.setState({formErrors_commonErr:MSG_FILTER_COMMON_ERROR}); 
        //     this.props.onShowFilterBy(); 
        //     return false; 
        // }

        // VALIDATE WHETHER FROM DATE IS GREATER THAN TO DATE 
        let dateTimeFrom = new Date();
        let dateTimeTo   = new Date();
        if(this.state.includeDate) {
            dateTimeFrom = new Date(this.state.selectedStartDate);
            dateTimeTo = new Date(this.state.selectedEndDate); 
            if(dateTimeFrom > dateTimeTo) {
                foundIssues = 1;
                this.setState({formErrors_selectedToDate:MSG_REQUIRED}); 
                this.props.onShowFilterBy(); 
                return false;          
            }
        }  

        if(foundIssues===0) { 
            let filtersSelected = 0; 
            let arrClientIds = [];
            if(this.state.selectedClient && this.state.selectedClient.length) {
                this.state.selectedClient.forEach(item => {
                    if(Number(item.id) > 0) { 
                        arrClientIds.push(item.id);
                        filtersSelected = 1; 
                    }
                }) 
            }

            let arrEventIds = [];
            if(this.state.selectedEvent && this.state.selectedEvent.length) {
                this.state.selectedEvent.forEach(item => {
                    if(Number(item.id) > 0) {
                        arrEventIds.push(item.id);
                        filtersSelected = 1; 
                    }
                }) 
            }

            let arrReviewerIds = [];
            if(this.state.selectedReviewer && this.state.selectedReviewer.length) {
                this.state.selectedReviewer.forEach(item => {
                    if(Number(item.id) > 0) {
                        arrReviewerIds.push(item.id);
                        filtersSelected = 1; 
                    }
                }) 
            }

            let arrChiefReviewerIds = [];
            if(this.state.chief_selectedReviewer && this.state.chief_selectedReviewer.length) {
                this.state.chief_selectedReviewer.forEach(item => {
                    if(Number(item.id) > 0) {
                        arrChiefReviewerIds.push(item.id);
                        filtersSelected = 1; 
                    }
                }) 
            }

            let arrStarRatingIds = []; 
            this.state.starRatingIds.forEach(item => { arrStarRatingIds.push(Number(item)); }); 
            if(arrStarRatingIds.length) filtersSelected = 1; 

            let fromDate = 0; 
            let endDate = 0;
            if(this.state.includeDate) {
                fromDate = format(new Date(this.state.selectedStartDate), 'yyyy-MM-dd');
                endDate = format(new Date(this.state.selectedEndDate), 'yyyy-MM-dd');
                filtersSelected = 1;
            }

            if(this.state.selectedDepartments && this.state.selectedDepartments.length) {
                this.state.selectedDepartments.forEach(item => {
                    if(Number(item) > 0) {
                        filtersSelected = 1; 
                    }
                }) 
            }
            
            let filterData = {clientsIds:arrClientIds, eventIds:arrEventIds, reviewerIds:arrReviewerIds, chiefReviewerIds:arrChiefReviewerIds, starRatingIds:arrStarRatingIds, selectedStartDate:fromDate, selectedEndDate:endDate, filtersSelected:filtersSelected, actionTaken:this.state.selActionTaken, clientFeedback:this.state.selClientFeedback, crewFeedback:this.state.selCrewFeedback, departments:this.state.selectedDepartments}; 
            this.props.applyFilters(filterData); 
        }
    }

    componentDidMount() {
        this.props.feedbackGetChiefReviewersListAction(); 
        this.props.serverTimeAction();
        this.props.aflt_departmentsListAction(); 
    }

    loadMultiSelDeptValues = (needSendFilterData=false) => {
        let allDept = []; 
        let selectedDepartments = [];
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
              tmpObj = {value:item.id, label:titleCase(item.name), inputVal:1}; 
              allDept.push(tmpObj);
              selectedDepartments.push(item.id) 
           }) 
        }
        this.setState({deptMultiSelList:allDept,selectedDepartments:selectedDepartments}, () => {
            if(needSendFilterData) {
                this.sendFilterData(); 
            }
        });
        // this.setState({deptMultiSelList:allDept,selectedDepartments:selectedDepartments},()=>{
        //         this.sendFilterData()
        // });
     }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }

    componentDidUpdate (prevProps) {
        const {deptActivity,dataViewType,dataViewTypeClient,dataViewTypeChief} = this.props; 

        if(dataViewType!==prevProps.dataViewType && dataViewType===dataViewTypeClient && this.state.selCrewFeedback!=='all') {
            this.setState({selCrewFeedback:'all'});
        }
        else if(dataViewType!==prevProps.dataViewType && dataViewType===dataViewTypeChief && this.state.selClientFeedback!=='all') {
            this.setState({selClientFeedback:'all'});
        }

        if (deptActivity && deptActivity !== prevProps.deptActivity) {
            let deptArrTmp = [];
            deptArrTmp = (deptActivity && deptActivity.length) ? deptActivity.split('~~') : [];
            let deptActString = deptArrTmp[0]; 
            if(deptActString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) { 
                if(this.props.departmentsList.length===0) {
                    this.setState({departmentsList: []}, () => {
                        this.loadMultiSelDeptValues(); 
                    } ); 
                }
                else {     
                    this.setState({departmentsList: this.props.departmentsList}, () => {
                        this.loadMultiSelDeptValues(); 
                    } );                  
                }
            }
        }

        if(this.props.serverTimeListActivity && (this.props.serverTimeListActivity !== prevProps.serverTimeListActivity || this.props.negativeFeedback===true)){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                let defaultStartDate = new Date();
                defaultStartDate = new Date(defaultStartDate.setDate(defaultEndDate.getDate() - 30));
                this.setState({selectedStartDate:defaultStartDate,selectedEndDate:defaultEndDate},()=>{
                    defaultStartDate = format(defaultStartDate,'dd/MM/yyyy');
                    this.props.feedbackTitle(this.props.feedbackTitleText+ ' (from '+defaultStartDate+')');
                    this.sendFilterData(); 
                })
                if(this.props.negativeFeedback){
                    this.props.fromDashboard(false);
                }
                
            }
        } 

        if(this.props.filterClicked!==prevProps.filterClicked && this.state.clientListCalled===0) {
            this.setState({clientListCalled:1}); // TO PREVENT REPEATED API CALLS 
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                let dataObj = {isEvent:1, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
                this.props.feedbackFilterEventsListAction(dataObj); 
                this.props.feedbackFilterReviewersListAction(dataObj);
            }
            else {
                let dataObj = {isEvent:1}; 
                this.props.filterClientsListAction(); 
                this.props.feedbackFilterEventsListAction(dataObj); 
                this.props.feedbackFilterReviewersListAction(dataObj);
            }
        } 

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }

        const {filterClientsList,eventsFilterStatus,eventsFilterActivity,eventsFilterErrorData,filterFeedbackEventsList,filterActivity,filterStatus,filterErrorData,filterFeedbackStatus,filterFeedbackActivity, filterFeedbackErrorData, filterFeedbackReviewersList, filterChiefReviewersList} = this.props; 
        

        if (filterActivity && filterActivity !== prevProps.filterActivity) {
            let arrTmp = [];
            arrTmp = (filterActivity && filterActivity.length) ? filterActivity.split('~~') : [];
            let actString = arrTmp[0]; 

            if(actString===types.FILTER_CLIENTS_LIST_SUCCESS) { 
                let clientsOptions = [];  
                if(filterStatus===200) {
                    if(filterClientsList && Array.isArray(filterClientsList)){
                        filterClientsList.forEach(item => {             
                            clientsOptions.push({id:item.client_id, name:item.client_name});
                        });            
                    }
                }
                else {
                    console.log('Clients List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({clientsOptions}); 
            }
        }

        if (filterFeedbackActivity && filterFeedbackActivity !== prevProps.filterFeedbackActivity) {
            let arrTmp = [];
            arrTmp = (filterFeedbackActivity && filterFeedbackActivity.length) ? filterFeedbackActivity.split('~~') : [];
            let actString = arrTmp[0]; 

            let eventsOptions = [];  
            let reviewerOptions = [];  
            let chief_reviewerOptions = [];  

            if(actString===types.CHIEF_REVIEWERS_LIST_SUCCESS) { 
                if(filterFeedbackStatus===200) {
                    if(filterChiefReviewersList && Array.isArray(filterChiefReviewersList)){
                        filterChiefReviewersList.forEach(item => {             
                            chief_reviewerOptions.push({id:item.reviewer_id, name:item.reviewer_name});
                        });            
                    }
                }
                else {
                    console.log('Chief Reviewera List Error '+JSON.stringify(filterFeedbackErrorData)); 
                }
                this.setState({chief_reviewerOptions}); 
            } 
            else if(actString===types.FEEDBACK_FILTER_EVENTS_LIST_SUCCESS) { 
                if(filterFeedbackStatus===200) {
                    if(filterFeedbackEventsList && Array.isArray(filterFeedbackEventsList)){
                        filterFeedbackEventsList.forEach(item => {             
                            eventsOptions.push({id:item.event_id, name:item.event_title});
                        });            
                    }
                }
                else {
                    console.log('Events List Error '+JSON.stringify(filterFeedbackErrorData)); 
                }
                this.setState({eventsOptions}); 
            }
            else if(actString===types.FEEDBACK_FILTER_EVENTS_LIST_ERROR) {
                console.log('Events List Error '+JSON.stringify(filterFeedbackErrorData)); 
                this.setState({eventsOptions}); 
            }
            else if(actString===types.FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS) { 
                if(filterFeedbackStatus===200) {
                    if(filterFeedbackReviewersList && Array.isArray(filterFeedbackReviewersList)){
                        filterFeedbackReviewersList.forEach(item => {             
                            reviewerOptions.push({id:item.reviewer_id, name:item.reviewer_name});
                        });            
                    }
                }
                else {
                    console.log('Reviewer List Error '+JSON.stringify(filterFeedbackErrorData)); 
                }
                this.setState({reviewerOptions}); 
            }
            else if(actString===types.FEEDBACK_FILTER_REVIEWERS_LIST_ERROR) { 
                console.log('Reviewer List Error '+JSON.stringify(filterFeedbackErrorData)); 
                this.setState({reviewerOptions}); 
            }
        }
    }


    render(){

        let {selectedClient,clientsOptions, selectedEvent,eventsOptions, selectedReviewer, chief_selectedReviewer, chief_selectedReviewerId, reviewerOptions, chief_reviewerOptions, selectedStartDate, selectedEndDate, includeDate,dateValue, formErrors_commonErr, formErrors_selectedToDate} = this.state; 
            
        let paddingTopPix = 350;
        if(this.props.negativeFeedback){
            let negArray = [1,2]
            starRatingData.map(rateItem => {
                if(rateItem.value == 1 || rateItem.value == 2){
                    rateItem.inputVal = 1;
                }
                return rateItem;
            });
            this.setState({starRatingIds:negArray,selActionTaken:FEEDBACK_ACTION_REQUIRED});
        }

        let location = window.location; 
        let userGroupData = userGroupUrlCheck(location);
        let crew_chief_text = 'Chief'; 
        if(userGroupData!==undefined){
            crew_chief_text = userGroupData.supervisor_name && userGroupData.supervisor_name.length ? userGroupData.supervisor_name : 'Chief'; 
        }

        return(
            <>
                {!this.props.isClientPage &&  
                <div className="filter-category">
                    <h4>{LBL_CLIENT}</h4>
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedClient}
                                id="clients"
                                labelKey="name"
                                options={clientsOptions}
                                placeholder="Choose Client..."
                                inputProps={{ name:'clientId', className:''}}
                                onChange={(s) => this.handleClientChange(s)}
                                onInputChange={this.handleRemoveClient}
                            />  
                        </div>
                    </div>
                </div>}

                <div className="filter-category">
                    <h4>{LBL_EVENT+' '+LBL_TITLE}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedEvent} 
                                id="events"
                                labelKey="name"
                                options={eventsOptions}
                                placeholder={"Choose "+' '+LBL_EVENT+"..."}
                                inputProps={{ name:'eventId', className:''}}
                                onChange={(s) => this.handleEventChange(s)}
                                onInputChange={this.handleRemoveEvent}
                            />  
                        </div>
                    </div>
                </div>

                {this.props.dataViewType===this.props.dataViewTypeClient && <div className="filter-category">
                    <h4>{LBL_REVIEWED_BY_CLIENT_ASSOC}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedReviewer}  
                                id="reviewdby"
                                labelKey="name"
                                options={reviewerOptions} 
                                placeholder="Choose Reviewd by..."
                                inputProps={{ name:'reviewerId', className:''}}
                                onChange={(s) => this.handleReviewedbyChange(s)}
                                onInputChange={this.handleRemoveReviewedby}
                            />  
                        </div>
                    </div>
                </div>}

                {!this.props.isClientPage && this.props.dataViewType===this.props.dataViewTypeChief &&  <div className="filter-category">
                    <h4>{LBL_REVIEWED_BY+' ('+this.props.crew_chief_text+')'}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={chief_selectedReviewer}  
                                id="chief_reviewdby"
                                labelKey="name"
                                options={chief_reviewerOptions} 
                                placeholder="Choose Reviewd by..."
                                inputProps={{ name:'reviewerId', className:''}}
                                onChange={(s) => this.handleChiefReviewedbyChange(s)}
                                onInputChange={this.handleRemoveChiefReviewedby}
                            />  
                        </div>
                    </div>
                </div> } 

                <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_CREW+' / '+LBL_RATING}</h4>
                        <div className="form-group multisel_textbox">
                            <div className="form-group select-input skills" >
                                <CustomMultiSelect data={starRatingData}  onChange={selected =>this.onStarRatingDataChange(selected)} isTextBox={false} needSelectAll={true} />
                            </div>
                        </div>
                    </div> 
                </div>  

                {!this.props.isClientPage && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_ACTION_TAKEN}</h4> 
                        <div className="select-input">  
                            <select onChange={(e) => this.onActionTakenDataChange(e)} name="selActionTaken" value={this.state.selActionTaken} >  
                                <option value={FEEDBACK_ACTION_DEFAULT} >{LBL_ALL}</option>
                                <option value={FEEDBACK_ACTION_TAKEN} >{LBL_YES}</option>
                                <option value={FEEDBACK_ACTION_REQUIRED} >{LBL_NO}</option> 
                            </select>                           
                        </div>
                    </div> 
                </div> }
                
                {!this.props.isClientPage && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_DEPARTMENTS}</h4>
                        <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                <CustomMultiSelect id={'dept'} data={this.state.deptMultiSelList} trimString='yes'  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"10" }} tabIndex="10" needSelectAll={true} />
                                </div>
                        </div> 
                    </div>
                </div> }  

                
                <div className="filter-category">                   
                    <div className="row"> 
                        <div className="col-6"> <h4>
                        <div className="custom-checkbox"> 
                                <input type="checkbox" id="includeDate" name="includeDate"  checked={includeDate} value={dateValue} onChange={e => this.onDateCheck(e)} />
                                <label className="checkbox" htmlFor="includeDate" ></label>
                                <label htmlFor="includeDate" > &nbsp; {LBL_SHIFT_DATE_FROM} </label> 
                            </div></h4>
                        </div>
                        <div className="col-6 paddingTop7"> <h4>{LBL_DATE_TO}</h4></div>
                    </div>
                    <div className="form-group">
                        <div className="form-group"> 
                            <div className="row">
                                <div className="col-6">
                                    <div className="calendar-input">  
                                        <DatePicker 
                                            selected={selectedStartDate}
                                            onChange={selected => this.onStartDateChange(selected)}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            // minDate={new Date()}
                                            fixedHeight   
                                            disabled={!includeDate}       
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="calendar-input ">  
                                        <DatePicker 
                                            selected={selectedEndDate}
                                            onChange={selected => this.onEndDateChange(selected)}
                                            name="endDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            minDate={new Date(selectedStartDate)}
                                            fixedHeight     
                                            disabled={!includeDate}    
                                            className={formErrors_selectedToDate.length >0 ? "input-error" : ''}    
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                <div> &nbsp; </div>
                <div> &nbsp; </div>
                {!this.props.isClientPage && this.props.dataViewType===this.props.dataViewTypeClient &&  <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_FILTER_CLIENT_FEEDBACK}</h4> 
                        <div className="select-input">  
                            <select onChange={(e) => this.onFeedbackTypeChange(e, "selClientFeedback")} name="selClientFeedback" value={this.state.selClientFeedback} >  
                                <option value={'all'} >{LBL_ALL}</option>
                                <option value={'true'} >{LBL_YES}</option>
                                <option value={'false'} >{LBL_NO}</option> 
                            </select>                           
                        </div>
                    </div> 
                </div> }

                {!this.props.isClientPage && this.props.dataViewType===this.props.dataViewTypeChief && <div className="filter-category">
                    <div className="form-group">
                        <h4>{stringFormat(LBL_FILTER_CHIEF_FEEDBACK,crew_chief_text)}</h4> 
                        <div className="select-input">  
                            <select onChange={(e) => this.onFeedbackTypeChange(e, "selCrewFeedback")} name="selCrewFeedback" value={this.state.selCrewFeedback} >  
                                <option value={'all'} >{LBL_ALL}</option>
                                <option value={'true'} >{LBL_YES}</option>
                                <option value={'false'} >{LBL_NO}</option> 
                            </select>                           
                        </div>
                    </div> 
                </div> }  
                
                <div> &nbsp; </div>
                {/* {formErrors_commonErr.length > 1 && <div className="text-red"><small>{formErrors_commonErr}</small></div>} */}

                {/* <div style={{paddingTop:paddingTopPix}}></div> */}

            </>
        )
    }

}

const mapStateToProps = (state) => { 
    return {
        filterClientsList: state.event.filterClientsList, 
        filterStatus: state.event.filterStatus,
        filterActivity: state.event.filterActivity,
        filterErrorData: state.event.filterErrorData,

        filterFeedbackStatus: state.filterItems.filterFeedbackStatus,
        filterFeedbackActivity: state.filterItems.filterFeedbackActivity,
        filterFeedbackEventsList: state.filterItems.filterFeedbackEventsList, 
        filterFeedbackErrorData: state.filterItems.filterFeedbackErrorData,
        negativeFeedback: state.commons.fromDashboard,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
        filterFeedbackReviewersList: state.filterItems.filterFeedbackReviewersList,
        filterChiefReviewersList: state.filterItems.filterChiefReviewersList,

        departmentsList : state.afltDepartments.departmentsList,
        deptActivity:state.afltDepartments.activity,
        
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        filterClientsListAction:filterClientsListAction, 
        feedbackFilterEventsListAction:feedbackFilterEventsListAction,
        feedbackFilterReviewersListAction:feedbackFilterReviewersListAction,
        feedbackGetChiefReviewersListAction:feedbackGetChiefReviewersListAction, 
        fromDashboard:fromDashboard,
        serverTimeAction:serverTimeAction,
        feedbackTitle:feedbackTitle,
        aflt_departmentsListAction:aflt_departmentsListAction,
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterFeedback);
